import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { EditorModule } from 'primeng/editor';
import { LeadService } from 'src/app/private/services/lead.service';
import { MessageService } from 'primeng/api';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CommunicationNoteComponent } from "../communication-note/communication-note.component";
import { EmailTemplateService } from 'src/app/private/services/email-template.service';
import Quill from 'quill';
@Component({
  selector: 'app-lead-email',
  imports: [ButtonModule, FormsModule, InputTextModule, EditorModule, SharedModule, CommunicationNoteComponent],
  templateUrl: './lead-email.component.html',
  styleUrl: './lead-email.component.scss'
})
export class LeadEmailComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Output() removeSelectedProducts = new EventEmitter<any>();

  @Input() selectedProducts: any = [];
  @Input() isBulk = false;

  emailSubject: string = '';
  emailBody: string = '';

  @Input() communicationData: any = {};

  loading = false;

  isOpenNotesModal = false;

  emailExtraDetails: any = {};

  attachments: any[] = [];

  constructor(
    private api: LeadService,
    private messageService: MessageService,
    private localStorage: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private emailTemplateService: EmailTemplateService
  ) { }

  currentSingature: any = '';

  ngOnInit() {

    this.cdr.detectChanges();
    this.loadSignature();

    const Block : any = Quill.import('blots/block');
    Block.tagName = 'div';
    Quill.register(Block, true);
  }

  loadSignature() {
    let signature = this.localStorage.getSignatures();
    signature?.forEach((element: any) => {
      if (element.isActive === true || element.isActive === 'true') {
        this.currentSingature = element.signature;
        this.emailBody = `<br><br><br><br>${this.currentSingature}`
      }
    });
  }


  
  parseDataToMakeEmptyDivToBr(data: string): string {
    // Replace empty <div> with <br>
    return data.replace(/<div><\/div>/g, '<br>');
  }


  handleSendEmail() {

    if (!this.emailSubject || !this.emailBody) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.emailSubject ? 'Email body is required' : 'Email subject is required' });
      return;
    }

    let bccEmails:any[] = [];

    if (this.isBulk) {
      this.selectedProducts.forEach((product: any) => {
        if (product.email) {
          bccEmails.push(product.email);
        }
      });
    }

    const payload = {
      user_id: this.localStorage.getUserId(),
      organization_id: this.localStorage.getOrganizationId(),
      subject: this.emailSubject,
      to: this.isBulk ? '' : this.communicationData?.email,
      bcc: this.isBulk ? bccEmails : [],
      cc: [],
      html: this.parseDataToMakeEmptyDivToBr(this.emailBody),
      text: '',
      attachments: this.attachments.map(att => att.url)
    }
    this.loading = true;
    this.api.sendCommunication(payload).subscribe({
      next: data => {
        this.emailExtraDetails = payload;
        this.loading = false;
        this.emailSubject = '';
        this.emailBody = '';
        this.attachments = [];
        this.loadSignature(); // Reload signature after clearing email body

        if(!this.isBulk) {
          this.isOpenNotesModal = true;
        }

        if (this.isBulk) {
          this.removeSelectedProducts.emit();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email sent successfully to all selected leads' });
        }else{
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email sent successfully' });
        }

      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to send email' });
      }
    }
    )


    

  }

  handleCloseNoteDialog() {
    this.closeDialog.emit()
  }


  handleCloseAllDialogs() {
    this.isOpenNotesModal = false;
    this.closeDialog.emit()
  }

  onFileSelect(event: any) {
    const files = event.files;
    if (files && files.length > 0) {
      for (let file of files) {
        this.uploadFile(file);
      }
    }
  }

  uploadFile(file: File) {
    // Add attachment with uploading state
    const attachment = {
      name: file.name,
      type: this.getFileType(file.name),
      uploading: true,
      url: ''
    };
    this.attachments.push(attachment);
    const attachmentIndex = this.attachments.length - 1;

    this.emailTemplateService.uploadFileToS3(file).subscribe(
      (response: any) => {
        if (response && response.url) {
          this.attachments[attachmentIndex].url = response.url;
          this.attachments[attachmentIndex].uploading = false;
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Success', 
            detail: 'File uploaded successfully' 
          });
        }
      },
      (error: any) => {
        console.error('Upload error:', error);
        this.attachments.splice(attachmentIndex, 1);
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Failed to upload file' 
        });
      }
    );
  }

  removeAttachment(index: number) {
    this.attachments.splice(index, 1);
  }

  getFileType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '')) return 'image';
    if (['mp4', 'avi', 'mov', 'wmv'].includes(ext || '')) return 'video';
    if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(ext || '')) return 'document';
    return 'document';
  }

  getFileTypeFromUrl(url: string): string {
    const fileName = url.split('/').pop() || '';
    return this.getFileType(fileName);
  }

  getFileNameFromUrl(url: string): string {
    return url.split('/').pop() || 'File';
  }

  getFileIcon(type: string): string {
    switch(type) {
      case 'image': return 'pi-image';
      case 'video': return 'pi-video';
      case 'document': return 'pi-file';
      default: return 'pi-file';
    }
  }

}
